import React from 'react';
import { Card, CardContent, Typography, Box } from '@mui/material';

const PaymentStatusCard = ({ 
  amount = '1,00,000', 
  title = 'EOI Amount',
  img,
}) => {
  return (
    <Card 
      sx={{
        borderRadius: '16px',
        backgroundColor: '#FFFFFF',
        boxShadow: '0 2px 8px rgba(145, 158, 171, 0.12)',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 3, height: '100%', position: 'relative' }}>
        <Typography 
          component="div" 
          sx={{ 
            fontSize: '22px',
            fontWeight: 700,
            color: '#1C252E',
            mb: 1,
          }}
        >
          ₹{amount}
        </Typography>
        
        <Typography 
          variant="body2" 
          sx={{ 
            color: '#637381',
            fontSize: '14px',
            fontWeight: 600
          }}
        >
          {title}
        </Typography>
        
        {/* Rounded Triangle */}
        <Box
        sx={{
          position: 'absolute',
          top: 0,
          right: 0,
          height: 120,
        }}>
          <img src={img} alt='triangle' />
        </Box>
      </CardContent>
    </Card>
  );
};

export default PaymentStatusCard;